import {Component, computed, input} from '@angular/core';
import {NgForOf} from "@angular/common";
import {ScorecardParticipant, ScorecardTeam} from "../../../model/participant-card-model";
import {GroupProfileImageComponent} from "../../../../../common/component/profile/group-profile-image/group-profile-image.component";
import {TotalScoreComponent} from "../total/total-score.component";
import {ParticipantTotalScore} from "../../../model/total-score";

@Component({
    selector: 'team-header',
    templateUrl: './team-header.component.html',
    imports: [
        GroupProfileImageComponent,
        TotalScoreComponent,
        NgForOf

    ],
    styleUrls: ['./team-header.component.css']
})
export class TeamHeaderComponent {
    participant = input<ScorecardParticipant | undefined>();
    totals = input<ParticipantTotalScore[]>([]);

    team = computed(() => {
        return this.participant() as ScorecardTeam
    });

    players = computed(() => {
        return this.team().players
            .map(player => player.name)
            .join(", ")
    });

    profileImages = computed(() => {
        return this.team().players.map(player => player.image)
    });

    trackByMethod(_: number, participantTotalScore: ParticipantTotalScore) {
        return participantTotalScore.method
    };
}
